import React from 'react'
import {
  Button,
  Table,
  TableBody,
  TableContainer,
  TableRow,
  TableHead,
  Box,
  Typography,
} from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { useIntl } from 'react-intl'
import Checkbox from '../../../../components/editors/checkbox/Checkbox'
import { colorPalette } from '../../../../style/colorPalette'
import { SprintAdjustmentItem } from './types'
import { TableHeaderCell, TableDataCell } from './StyledComponents'

interface Props {
  items: SprintAdjustmentItem[]
  onCheckChange: (sprintUuid: string, checked: boolean) => void
  onSwitchToWorkload: () => void
  formatDate: (dateStr: string) => string
}

export const SelectionModeView: React.FC<Props> = ({
  items,
  onCheckChange,
  onSwitchToWorkload,
  formatDate,
}) => {
  const intl = useIntl()

  return (
    <>
      {/* 戻るボタン */}
      <Box
        sx={{
          px: 3,
          py: 1,
          display: 'flex',
          justifyContent: 'flex-start',
          borderBottom: `1px solid ${colorPalette.monotone[2]}`,
        }}
      >
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={onSwitchToWorkload}
          size="small"
        >
          {intl.formatMessage({
            id: 'productBacklog.sprintInteractiveAdjustment.backToWorkload',
          })}
        </Button>
      </Box>
      {/* 説明テキスト */}
      <Box sx={{ px: 3, pt: 2, pb: 1 }}>
        <Typography variant="body2" color="textSecondary">
          {intl.formatMessage({
            id: 'productBacklog.sprintInteractiveAdjustment.selectSprintsDescription',
          })}
        </Typography>
      </Box>
      {/* チェックボックス一覧 */}
      <TableContainer sx={{ maxHeight: 400, px: 3, pb: 2 }}>
        <Table size="small" stickyHeader={true}>
          <TableHead>
            <TableRow>
              <TableHeaderCell padding="checkbox" />
              <TableHeaderCell>
                {intl.formatMessage({
                  id: 'productBacklog.sprintInteractiveAdjustment.sprint',
                })}
              </TableHeaderCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map(item => (
              <TableRow
                key={item.sprintUuid}
                hover={true}
                onClick={() => onCheckChange(item.sprintUuid, !item.checked)}
                sx={{ cursor: 'pointer' }}
              >
                <TableDataCell padding="checkbox">
                  <Checkbox
                    checked={item.checked}
                    onChange={(_, checked) =>
                      onCheckChange(item.sprintUuid, checked)
                    }
                    color="primary"
                  />
                </TableDataCell>
                <TableDataCell>
                  {item.sprintName}（{formatDate(item.startDate)}～
                  {formatDate(item.endDate)}）
                </TableDataCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  )
}
